module.exports = {
  textField : {
    fontFamily: 'Cochin',
  }
}



// WEBPACK FOOTER //
// ./src/ReUpStyle.js